import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import {GuestGuard} from './core/guards/GuestGuard';
import {UserGuard} from './core/guards/UserGuard';
import {AdvancedSearchCustomerComponent} from "./extra/customer/advanced-search-customer.component";
import {AdvancedSearchGeneralComponent} from "./extra/advanced-search-general.component";

export const Approutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [


      {
        path: 'rapid-search/:term',
        component: AdvancedSearchGeneralComponent,
        data: {
          title: 'جستجوی سریع',
          urls: [ { title: 'دشبود', url: '/dashboard/dashboard' },{ title: 'جستجوی سریع' }]
        }
      },
      { path: '', redirectTo: '/dashboard/dashboard', pathMatch: 'full' , canActivate:[UserGuard]},
      { path: 'dashboard', loadChildren: () => import('./dashboards/dashboard.module').then(m => m.DashboardModule), canActivate:[UserGuard] },
      { path: 'page', loadChildren: () => import('./entities/entity.module').then(m => m.EntityModule) },
      { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
      { path: 'charts', loadChildren: () => import('./charts/charts.module').then(m => m.ChartModule) },

      // { path: '', redirectTo: '/starter', pathMatch: 'full' },


      {
        path: 'starter',
        loadChildren: () => import('./starter/starter.module').then(m => m.StarterModule)
      }
      ,
      {
        path: 'component',
        loadChildren: () => import('./component/component.module').then(m => m.ComponentsModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule),
        canActivate:[GuestGuard]
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/starter'
  }
];

